export const isNullOrUndefined = <T>(value: T | undefined | null): value is null | undefined =>
  value === undefined || value === null;

export const isNotNullNorUndefined = <T>(value: T | undefined | null): value is T =>
  !isNullOrUndefined(value);

export const isEmptyObject = (obj: object | null | undefined): boolean =>
  !obj ? true : Object.keys(obj).length === 0;
